<template>
  <div class="about-page" :class="{ 'menu-open': menuOpen }">
    <!-- Header组件 - 与首页一致，使用黑色logo -->
    <Header
      :showLogo="true"
      theme="light"
      :fixed="true"
      :showBorder="isScrolled"
      backgroundColor="transparent"
      @menu-open="menuOpen = true"
      @menu-close="menuOpen = false"
      iconColor="black"
      :logoShrink="isScrolled"
    />
    
    <!-- 顶部标题和描述 -->
    <div class="about-header">
      <div class="header-content" style="margin-top: 220rem;">
        <h1 class="page-title font-apercu-medium">{{ pageTitle }}</h1>
        <div class="header-description" style="padding-bottom: 80rem;text-align: justify;">
          <p class="page-description">Based in Melbourne and led by artist and designer Steven John Clark, we create high-end furniture, lighting and objects somewhere between the useful and the unreasonable.</p>
        </div>
      </div>
    </div>

    <!-- 画廊与文本交替部分 -->
    <div class="alternating-sections">
      <!-- 第一部分: 图片在上，文字在下 -->
      <div class="alternating-section">
        <div class="gallery-grid">
          <div class="gallery-item small">
            <img :src="workshop1" alt="Workshop Interior" class="gallery-image" />
          </div>
          <div class="gallery-item small">
            <img :src="workshop2" alt="Workshop Detail" class="gallery-image" />
          </div>
        </div>
        <div class="header-description" style="margin: 0rem 80rem 0;max-width: 826rem;margin: auto;">
          <p class="page-description" style="padding-top: 200rem;padding-bottom: 200rem;text-align: justify;">
			 We ve spent a fair bit of time arguing with limestone, asking it to do things stone probably wasn't expecting to do. From there, things tend to wander..into bronze, glass, composites and whatever else seems worth getting our hands dirty with. There's a bit of mad scientist in us, admittedly.
			 </p>
        </div>
      </div>

      <div class="studio-image">
        <img :src="stone1" alt="Studio Environment" class="gallery-image" style="height: 810rem" />
      </div>

      <div class="split-section-2">

        <div class="header-description" style="margin: 0rem 80rem 0;max-width: 826rem;margin: auto;">
          <p class="page-description" style="padding-top: 157rem;padding-bottom: 170rem;text-align: justify;">
			  We like contradictions. Heavy things that appear to float. Rough things that feel strangely soft. We're not making factory-made cans of beans, all lined up nicely while little robots get on with it. That sounds terribly efficient, but we'd rather spend the time making something with character, something f*cking brilliant.
			  </p>
        </div>

        <div class="split-img">
          <div class="split-img-item">
            <img :src="stone2" alt="Studio Environment" class="gallery-image"
              style="max-height: 933rem !important;width: 933rem;width: 100%;" />
          </div>
          <div class="split-img-item">
            <img :src="stone3" alt="Studio Detail" class="gallery-image"
              style="max-height: 933rem !important;height: 933rem !important;width: 100%;" />
          </div>
        </div>

      </div>
    </div>

    <!-- Footer组件 -->
    <Footer layout="about" :show-general-enquires="true" :show-instagram="true" :show-studio="true"
      :show-decoration="true" @subscribe="handleSubscribe" />

  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import dsc1 from '../assets/about/about1.jpg'
import dsc2 from '../assets/about/about2.jpg'
import dsc3 from '../assets/about/about3.png'
import dsc4 from '../assets/about/about4.png'
import dsc5 from '../assets/about/about5.png'
import dsc6 from '../assets/about/about6.png'
import dsc7 from '../assets/about/about7.png'
import auth1 from '../assets/about/auth1.png'
import auth2 from '../assets/about/auth2.png'
import { getContentPage } from '@/api/content'

const HOME_DEFAULT = require('../assets/home_bg.jpg')

const HERO_MAP = {
  'collection-entry-table': require('../assets/Group 1-1.png'),
  'collection-console-table': require('../assets/Group 1-2.png'),
  'collection-coffee-table': require('../assets/Group 1-3.png'),
  'collection-side-table': require('../assets/Group 1-4.png'),
  'collection-chair': require('../assets/_DSC0544 2 3.png'),
  'collection-stool': require('../assets/_DSC0544 2 3-1.png'),
  'collection-planter': require('../assets/_DSC0544 2 4.png'),
  'collection-lighting': require('../assets/_DSC0544 2 3.png'),
  'collection-mirror': require('../assets/_DSC0544 2 3-1.png'),
  'collection-hardware': require('../assets/_DSC0544 2 4.png'),
  'collection-decor': require('../assets/_DSC0544 2 3.png'),
  'info-about-us': require('../assets/_DSC0544 2 4.png'),
  'info-founder': require('../assets/_DSC0544 2 3-1.png'),
  'projects-all-projects': require('../assets/_DSC0544 2 3.png')
}

export default {
  name: 'AboutPage',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      menuOpen: false,
      isScrolled: false,
      pageTitle: 'About denHolm',
      pageContent: 'Based in Melbourne and led by artist and designer Steven John Clark, denHolm is a multidisciplinary design studio established in the language of limestone. While limestone is our first muse, we also work across bronze, glass, plastic and beyond—creating high-end furniture, lighting, and objects that blur the line between art and utility.',
      workshop1: dsc1,
      workshop2: dsc2,
      stone1: dsc3,
      stone2: dsc6,
      stone3: dsc7,
      auth1,
      auth2,
      idleTimer: null,
      isIdle: false,
      animationStatus: 'off',
      cycleTimers: [],
      particles: []
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
    this.setupIdleListeners()
    this.resetIdleTimer()
    this.loadContent()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    this.removeIdleListeners()
    if (this.idleTimer) clearTimeout(this.idleTimer)
  },
  watch: {
    isIdle(val) {
      if (val) {
        this.startCycle()
      } else {
        this.stopCycle()
      }
    }
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0
      this.isScrolled = scrollTop > 50
    },
    onMenuOpen() {
      this.menuOpen = true
    },
    onMenuClose() {
      this.menuOpen = false
    },
    onHeroChange() {},
    startCycle() {
      this.generateParticles()
      this.runAnimationSequence()
    },
    stopCycle() {
      this.cycleTimers.forEach(t => clearTimeout(t))
      this.cycleTimers = []
      this.animationStatus = 'off'
      this.particles = []
    },
    runAnimationSequence() {
      this.cycleTimers.forEach(t => clearTimeout(t))
      this.cycleTimers = []

      const step = 0.08
      const duration = 0.5
      const totalTime = this.particles.length * step + duration
      const holdTime = 2

      this.animationStatus = 'entering'

      const leaveTimer = setTimeout(() => {
        this.animationStatus = 'leaving'

        const restartTimer = setTimeout(() => {
          this.animationStatus = 'off'
          this.runAnimationSequence()
        }, totalTime * 1000 + 5000)

        this.cycleTimers.push(restartTimer)
      }, (totalTime + holdTime) * 1000)

      this.cycleTimers.push(leaveTimer)
    },
    getDelay(i) {
      const step = 0.08
      if (this.animationStatus === 'entering') {
        return i * step
      } else if (this.animationStatus === 'leaving') {
        return (this.particles.length - 1 - i) * step
      }
      return 0
    },
    generateParticles() {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const width = window.innerWidth
      const height = window.innerHeight
      canvas.width = width
      canvas.height = height

      const fontSize = Math.floor(width * 0.20)
      ctx.font = `bold ${fontSize}px "Bespoke Serif", serif`
      ctx.fillStyle = 'black'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText('denHolm', width / 2, height / 2)

      const imageData = ctx.getImageData(0, 0, width, height)
      const data = imageData.data
      const particles = []
      const gap = 24

      for (let x = 0; x < width; x += gap) {
        for (let y = 0; y < height; y += gap) {
          const index = (y * width + x) * 4
          if (data[index + 3] > 80) {
            particles.push({
              x,
              y,
              img: particles.length % 2 === 0 ? this.auth1 : this.auth2,
              rotation: (Math.random() * 60) - 30,
              delay: particles.length * 0.08
            })
          }
        }
      }
      this.particles = particles
    },
    setupIdleListeners() {
      const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart', 'wheel']
      events.forEach(event => {
        window.addEventListener(event, this.resetIdleTimer)
      })
    },
    removeIdleListeners() {
      const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart', 'wheel']
      events.forEach(event => {
        window.removeEventListener(event, this.resetIdleTimer)
      })
    },
    resetIdleTimer() {
      this.isIdle = false
      if (this.idleTimer) clearTimeout(this.idleTimer)
      this.idleTimer = setTimeout(() => {
        this.isIdle = true
      }, 1000)
    },
    handleSubscribe(email) {
      console.log('Subscribing:', email)
    },
    async loadContent() {
      try {
        const response = await getContentPage({ pageType: 'AboutUs' })
        const content = response && response.result ? response.result : null
        if (content && (content.Title || content.ContentText)) {
          this.pageTitle = content.Title || this.pageTitle
          this.pageContent = content.ContentText || this.pageContent
        }
      } catch (error) {
        console.error('Failed to load about content:', error)
      }
    },
  }
}
</script>

<style scoped>
/* 基础样式 */
.about-page {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1a1a1a;
  position: relative;
}

/* ✅ 修复：移除 brightness 遮罩效果，与 Contact 页面一致 */
.about-page.menu-open {
  /* filter: brightness(0.7); */
  transition: filter 0.3s ease;
}

/* 顶部标题区域 */
.about-header {
  padding-top: 200rem;
}

.header-content {
  max-width: 826rem;
  margin: 0 auto;
}

.page-title {
  font-size: 24rem;
  font-weight: 700;
  margin: 0 0 40rem 0;
  color: #000;
  text-align: center;
}

.page-description {
  font-size: 16rem;
  color: #000;
  margin: 0;
  font-weight: 500;
  font-family: 'Apercu-Medium' !important;
}

/* 画廊网格布局 */
.gallery-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10rem;
}

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 2rem;
  height: 552rem;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-height: 810rem;
  transition: transform 0.6s ease;
}

.studio-image {
  max-width: 100%;
  height: 810rem;
  border-radius: 2rem;
  padding: 0 30rem 106rem 30rem;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .gallery-grid {
    grid-template-columns: 1fr;
    gap: 20rem;
  }

  .gallery-item {
    height: 500rem;
  }
}

@media (max-width: 768px) {
  .about-header {
    padding: 80rem 5% 60rem;
  }

  .page-title {
    font-size: 48rem;
  }

  .gallery-item {
    height: 400rem;
  }

  .studio-image {
    height: 500rem;
  }

  .alternating-sections {
    padding: 0 20rem;
  }
}

/* Split Section Layout */
.split-section-2 {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.split-img {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 19rem;
  padding: 0 71rem 87rem 71rem;
}

@media (max-width: 1024px) {
  .split-img {
    padding: 0 20rem 60rem;
    gap: 20rem;
  }
}

/* Idle Animation Styles */
.idle-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  overflow: hidden;
  background-color: transparent;
  pointer-events: none;
}

.particles-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  width: 20rem;
  height: 20rem;
}

.particle-inner {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transform: scale(0);
}

.particle-inner.entering {
  animation: particleAppear 0.5s ease forwards;
}

.particle-inner.leaving {
  animation: particleDisappear 0.5s ease both;
}

@keyframes particleAppear {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes particleDisappear {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>